import { exists } from '@/api'

export interface BatchStatisticsCollectionConditionListItem {
  acceptanceDateFrom: string
  acceptanceDateTo: string
  collectionTitle: string
  registBranchCodeFrom: string
  registBranchCodeTo: string
  collectionType: string
  collectionStatus: string
  removalCollection: string
  preAcceptance: string
  bookbinding: string
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  numberEnabled: boolean
  amountOfMoneyEnabled: boolean
  isOutputFull: boolean
  collectionMemo: string
  batchType: string
}

export function BatchStatisticsCollectionConditionListItemFromJSON(
  json: any
): BatchStatisticsCollectionConditionListItem {
  const resp = JSON.parse(json)

  return {
    acceptanceDateFrom: exists(resp, 'acceptance_date_from')
      ? resp.acceptance_date_from
      : '',
    acceptanceDateTo: exists(resp, 'acceptance_date_to')
      ? resp.acceptance_date_to
      : '',
    collectionTitle: exists(resp, 'title') ? resp.title : '',
    registBranchCodeFrom: exists(resp, 'regist_branch_code_from')
      ? resp.regist_branch_code_from
      : '',
    registBranchCodeTo: exists(resp, 'regist_branch_code_to')
      ? resp.regist_branch_code_to
      : '',
    collectionType: exists(resp, 'collection_type')
      ? resp.collection_type
      : '1',

    collectionStatus: exists(resp, 'collection_status')
      ? resp.collection_status
      : '',
    removalCollection: exists(resp, 'removal_collection')
      ? resp.removal_collection
      : '1',
    preAcceptance: exists(resp, 'pre_acceptance') ? resp.pre_acceptance : '1',
    bookbinding: exists(resp, 'bookbinding') ? resp.bookbinding : '1',
    xItem: resp.x_item,
    yItem1: resp.y_item1,
    yCheck1: exists(resp, 'y_check1') ? resp.y_check1 : [false, false],
    yItem2: exists(resp, 'y_item2') ? resp.y_item2 : '',
    yCheck2: exists(resp, 'y_check2') ? resp.y_check2 : [false, false],
    yItem3: exists(resp, 'y_item3') ? resp.y_item3 : '',
    yCheck3: exists(resp, 'y_check3') ? resp.y_check3 : [false, false],
    yItem4: exists(resp, 'y_item4') ? resp.y_item4 : '',
    yCheck4: exists(resp, 'y_check4') ? resp.y_check4 : [false, false],
    numberEnabled: exists(resp, 'number_enabled') ? resp.number_enabled : false,
    amountOfMoneyEnabled: exists(resp, 'amount_of_money_enabled')
      ? resp.amount_of_money_enabled
      : false,
    isOutputFull: exists(resp, 'is_output_full') ? resp.is_output_full : false,
    collectionMemo: resp.memo,
    batchType: resp.batch_type
  }
}
